import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LocationdocumentsService } from '../../services/locationdocuments/locationdocuments.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
@Component({
  selector: 'app-agent-locationdocs-delete-dialog',
  templateUrl: './agent-locationdocs-delete-dialog.component.html',
  styleUrls: ['./agent-locationdocs-delete-dialog.component.css']
})
export class AgentLocationdocsDeleteDialogComponent implements OnInit {
  logFormData: any;
  agentId: any;
  loginId: any;
  errMsg;
  errFlag: boolean = false;
  vendorName;
  firstName;
  lastName;

  constructor(private googleAnalyticsService: GoogleAnalyticsService,  private changelogservice: ChangeLogService, private locationDocumentsService: LocationdocumentsService, public dialogRef: MatDialogRef<AgentLocationdocsDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public agentData: any) { }
    onNoClick(): void {
      this.dialogRef.close();
    }

  ngOnInit() {
    this.vendorName = localStorage.getItem('AgentName');
    this.agentId = localStorage.getItem("AgentId");
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
  }
  deleteDocument(){
    this.logFormData = {
      "document_type": this.agentData.DocumentTypeName,
      "document_category": this.agentData.DocumentCategory,
      "transaction_type": "Delete",
      "vendor_id": this.agentId
    }
    this.logFormData.location_id = localStorage.getItem('LocationId');
    this.locationDocumentsService.deleteDueDocuments(this.agentData, this.agentId).subscribe(res=>{
      this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Delete a" + ' ' + this.agentData.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
      if(res.Status == 200){
      this.locationDocumentsService.load.next('success');
      this.logFormData.modified_by = this.loginId;
      this.changelogservice.sendLogs(this.logFormData).subscribe(res => {},err=>{this.errMsg = err;this.errFlag = true;
      });
      this.onNoClick();
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/agent-locationdocs-delete-dialog/agent-locationdocs-delete-dialog.component.ts